__turbopack_context__.v({
  "franchise_hero": "FranchiseHero-module-scss-module__z4XoXW__franchise_hero",
  "franchise_hero_back_button": "FranchiseHero-module-scss-module__z4XoXW__franchise_hero_back_button",
  "franchise_hero_background_image": "FranchiseHero-module-scss-module__z4XoXW__franchise_hero_background_image",
  "franchise_hero_description": "FranchiseHero-module-scss-module__z4XoXW__franchise_hero_description",
  "franchise_hero_description_expanding": "FranchiseHero-module-scss-module__z4XoXW__franchise_hero_description_expanding",
  "franchise_hero_description_full": "FranchiseHero-module-scss-module__z4XoXW__franchise_hero_description_full",
  "franchise_hero_description_more_button": "FranchiseHero-module-scss-module__z4XoXW__franchise_hero_description_more_button",
  "franchise_hero_name": "FranchiseHero-module-scss-module__z4XoXW__franchise_hero_name",
  "franchise_hero_overlay": "FranchiseHero-module-scss-module__z4XoXW__franchise_hero_overlay",
  "sponsorship_row__top": "FranchiseHero-module-scss-module__z4XoXW__sponsorship_row__top",
});
